import windowSize from "../shared/helpers/window_size";

function initializeMap() {
  if (windowSize.isMaxWidth("640")) {
    return;
  }

  const googleMaps = window.google && window.google.maps;
  const mapContainer = document.querySelector("[data-google-map]");

  if (!googleMaps || !mapContainer) {
    return;
  }

  const infoWindow = new googleMaps.InfoWindow();
  const { lat, lng, marker } = mapContainer.dataset;
  const latLng = new googleMaps.LatLng(lat, lng);

  const options = {
    scrollwheel: false,
    draggable: !windowSize.isSmallPalm(),
    zoom: 8,
    center: latLng,
    streetViewControlOptions: {
      position: googleMaps.ControlPosition.LEFT_BOTTOM
    },
    zoomControlOptions: {
      position: googleMaps.ControlPosition.LEFT_BOTTOM
    },
    styles: [{
      stylers: [
        { visibility: "simplified" },
        { saturation: -25 },
        { lightness: 25 }
      ]
    }]
  };

  const map = new googleMaps.Map(mapContainer, options);

  const mapMarker = new googleMaps.Marker({
    position: latLng,
    map: map
  });

  googleMaps.event.addListener(mapMarker, "click", () => {
    infoWindow.setContent(marker);
    infoWindow.open(map, mapMarker);
  });

  googleMaps.event.addListener(map, "click", () => {
    infoWindow.close();
  });

  infoWindow.setContent(marker);
}

export default initializeMap;



// WEBPACK FOOTER //
// ./components/venue_map.js